module.exports = __webpack_public_path__ + "img/tpc-30.e9c77705.jpg";